import { get } from 'lodash';
import { EMPTY, of } from 'rxjs';
import { catchError, finalize, map, switchMap } from 'rxjs/operators';
import { Urls } from '@imaginelearning/web-api-core';
import { ApiProduct } from '../../constants/apiProducts';
import { AuthJwt, ClientId, UserRole } from '@imaginelearning/web-auth';
import { ApplicationConstants } from '../../app.constants';
import { LoginType, SSOHelpers } from '../../services/sso.helpers';
import { ClientDetector, Clients } from '../../services/client.detector';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../services/logging.service";
import * as i3 from "../../services/featureflag.service";
import * as i4 from "../../services/permissions.service";
import * as i5 from "@angular/router";
import * as i6 from "@imaginelearning/web-api-core";
import * as i7 from "@angular/common";
function SSOComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 8);
} }
function SSOComponent_section_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "section");
    i0.ɵɵelement(1, "hr");
    i0.ɵɵelementStart(2, "span")(3, "a");
    i0.ɵɵtext(4, "Error Details: ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r0.viewModel.serverMessage);
} }
function isLtiLogin(role, encryptedToken, siteCode, signature) {
    if (role && encryptedToken && siteCode && signature) {
        return true;
    }
    return false;
}
export class SSOComponent {
    constructor(http, loggingService, featureFlagService, permissionsService, activatedRoute, environment) {
        this.http = http;
        this.loggingService = loggingService;
        this.featureFlagService = featureFlagService;
        this.permissionsService = permissionsService;
        this.activatedRoute = activatedRoute;
        this.environment = environment;
        this.viewModel = {
            title: `${ApplicationConstants.initiatingSSOLogin}`,
            message: '',
            serverMessage: undefined
        };
        this.showLoadingImage = true;
        this.authApiRootUrl = null;
        this.authenticateWithIMLP = false;
        this.subscription = null;
        this.helpers = new SSOHelpers(this.environment, this.http);
        this.authApiRootUrl = Urls.get(this.environment.config.ENV).unVersionedApiUrl;
    }
    ngOnDestroy() {
        if (!!this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    ngOnInit() {
        let observable = undefined;
        let realmName = 'auth0';
        this.viewModel.message = ApplicationConstants.validatingCredentials;
        this.ssoContext = this.retrieveSsoContext();
        this.loggingService.init(get(this.activatedRoute, 'snapshot.queryParams', {}));
        // For LTI login & Launcher direct logins
        if (isLtiLogin(this.ssoContext.role, this.ssoContext.encryptedToken, this.ssoContext.siteCode, this.ssoContext.signature)) {
            observable = this.ltiLogin();
        }
        else {
            if (this.ssoContext.token === null) {
                this.showLoadingImage = false;
                this.viewModel = {
                    title: ApplicationConstants.authenticationFailed,
                    message: ApplicationConstants.pleaseContactSupport,
                    serverMessage: ApplicationConstants.invalidCodeGiven
                };
                this.loggingService.error(`SSOComponent::OnInit: ${ApplicationConstants.authenticationFailed}`, {
                    error: { message: 'Invalid route parameters - missing token' },
                    realmName
                });
            }
            else {
                this.loggingService.log(`SSOComponent::OnInit: Student SSO login token start.`, {
                    code: this.ssoContext.ssoCode,
                    realmName,
                    encryptedToken: this.ssoContext.encryptedToken,
                    signature: this.ssoContext.signature
                });
                const playerClient = ClientDetector.detectClient();
                //invalid values for ssoProvidedProduct implies L&L
                if (this.ssoContext.product === null || this.ssoContext.product === undefined || this.ssoContext.product === '') {
                    this.ssoContext.product = ApiProduct.ILE;
                }
                // Create flagContext AFTER setting default product value
                const flagContext = {
                    userId: this.ssoContext.userId,
                    email: this.ssoContext.email,
                    role: this.ssoContext.role,
                    product: this.ssoContext.product
                };
                this.authenticateWithIMLP =
                    playerClient === Clients.Html5 ||
                        (this.ssoContext.product !== ApiProduct.Spanish && this.ssoContext.product !== ApiProduct.ILE);
                if (this.authenticateWithIMLP) {
                    observable = this.helpers
                        .SsoOAuthLogin(this.ssoContext.token, this.ssoContext.product, this.featureFlagService, flagContext)
                        .pipe(catchError(error => this.handleError(error, realmName, this.ssoContext.token)), finalize(() => {
                        this.showLoadingImage = false;
                    }));
                }
                else {
                    if (this.ssoContext.role.match(/student/i)) {
                        observable = this.helpers.getImlpUrls(this.featureFlagService, flagContext).pipe(switchMap(urls => {
                            return this.helpers
                                .SSOLogin(urls.imlpApiUrl, this.ssoContext.token, this.ssoContext.signature, ClientId.WebGLClient, this.ssoContext.product)
                                .pipe(switchMap((response) => {
                                var user = new AuthJwt(response?.access_token);
                                this.loggingService.log(`SSOComponent::OnInit: Student SSO login success.`, {
                                    code: this.ssoContext.ssoCode,
                                    realmName,
                                    ssoDetails: {
                                        SiteCode: user?.siteCodes,
                                        Signature: 'abc',
                                        Role: user?.role,
                                        EncryptedToken: response?.access_token
                                    }
                                });
                                return this.studentLogin({
                                    SiteCode: user?.siteCodes,
                                    Signature: 'abc',
                                    Role: user?.role,
                                    EncryptedToken: response?.access_token,
                                    UserId: user?.sub,
                                    CheckBenchmark: true,
                                    LoginType: LoginType.SSOOAuthFlow
                                }, {
                                    Token: this.ssoContext.token,
                                    Product: this.ssoContext.product,
                                    Role: null,
                                    Signature: null
                                });
                            }));
                        }), catchError(error => this.handleError(error, realmName, this.ssoContext.token)), finalize(() => {
                            this.showLoadingImage = false;
                        }));
                    }
                    else {
                        observable = this.helpers.getImlpUrls(this.featureFlagService, flagContext).pipe(switchMap(urls => {
                            return this.helpers
                                .SSOLogin(urls.imlpApiUrl, this.ssoContext.token, this.ssoContext.signature, ClientId.Portal)
                                .pipe(switchMap((response) => {
                                var user = new AuthJwt(response?.access_token);
                                this.loggingService.log(`SSOComponent::OnInit: Educator SSO login success.`, {
                                    role: user?.role,
                                    code: this.ssoContext.ssoCode,
                                    siteCode: user?.siteCodes
                                });
                                return of(this.navigate(`${this.environment.config.pssUrl}`));
                            }));
                        }), catchError(error => this.handleError(error, realmName, this.ssoContext.token)), finalize(() => {
                            this.showLoadingImage = false;
                        }));
                    }
                }
                this.subscription = observable?.subscribe() ?? undefined;
            }
        }
    }
    retrieveSsoContext() {
        let ssoCode = get(this.activatedRoute, 'snapshot.queryParams.code', 'ClassLink');
        let role = get(this.activatedRoute, 'snapshot.queryParams.Role');
        let encryptedToken = get(this.activatedRoute, 'snapshot.queryParams.EncryptedToken');
        let siteCode = get(this.activatedRoute, 'snapshot.queryParams.SiteCode');
        let signature = get(this.activatedRoute, 'snapshot.queryParams.Signature');
        let userId = null;
        let email = null;
        let product = null;
        let token = null;
        if (!isLtiLogin(role, encryptedToken, siteCode, signature)) {
            if (window.document.location.href.indexOf('access_token=') > -1) {
                // For Auth0/SAML logins
                // Do note we have to manually decode the query params
                // Reason - Valid query param format - url?param1=value1&param2=value2.
                // But the one that we get from Auth0 (and this cannot change) is url#param1=value1&param2=value2.
                // Do note the difference in ? and #. Due to the # angular cannot decode the query params. Thus the manual step.
                token = window.document.location.href.substring(window.document.location.href.indexOf('access_token=') + 13);
                // We only need the access token. Ignore the rest of the parameters in the query params.
                // If there are no other params then we already have the accesstoken. No need to do a substring.
                if (token.indexOf('&') !== -1) {
                    token = token.substring(0, token.indexOf('&'));
                }
                if (token) {
                    userId = this.helpers.getUserIdFromToken(token);
                    email = this.helpers.getEmailFromToken(token);
                    role = this.helpers.getRoleFromToken(token);
                    product = this.helpers.getIntendedProduct(token);
                }
            }
        }
        return {
            ssoCode: ssoCode,
            role: role,
            encryptedToken: encryptedToken,
            siteCode: siteCode,
            signature: signature,
            userId: userId,
            email: email,
            product: product,
            token: token
        };
    }
    handleError(error, realmName, token) {
        const invalid_code = error?.data?.message?.match(/invalid code/gi);
        this.viewModel = {
            title: ApplicationConstants.authenticationFailed,
            message: ApplicationConstants.pleaseContactSupport,
            serverMessage: invalid_code
                ? ApplicationConstants.invalidCodeMessage
                : error?.data?.message || ApplicationConstants.detailsNotAvailable
        };
        this.loggingService.error(`SSOComponent::OnInit: ${ApplicationConstants.authenticationFailed}: `, {
            error,
            token,
            realmName
        });
        return EMPTY;
    }
    navigate(url) {
        window.location.href = url;
    }
    studentLogin(ssoDetails, loginFlowDetails) {
        return this.helpers
            .getStudentLaunchUrl(ssoDetails, loginFlowDetails, this.featureFlagService, this.permissionsService)
            .pipe(map(redirectUrl => this.navigate(redirectUrl)));
    }
    ltiLogin() {
        if (this.ssoContext.role === UserRole.student) {
            return this.studentLogin({
                SiteCode: this.ssoContext.siteCode,
                EncryptedToken: this.ssoContext.encryptedToken,
                Signature: this.ssoContext.signature,
                Role: this.ssoContext.role,
                UserId: this.ssoContext.userId,
                CheckBenchmark: false,
                LoginType: LoginType.LtiFlow
            }, {
                Token: this.ssoContext.token,
                Product: this.ssoContext.product,
                Role: null,
                Signature: null
            });
        }
        else {
            return this.ltiTeacherLogin();
        }
    }
    ltiTeacherLogin() {
        this.loggingService.log(`SsoController::ltiTeacherLogin: Authenticating educator through LTI.`, {});
        return this.helpers.SSOLogin(this.authApiRootUrl, this.ssoContext.encryptedToken, this.ssoContext.signature).pipe(map(response => {
            this.loggingService.log(`SsoController::ltiTeacherLogin: educator authenticated through LTI.`, response);
            this.navigate(`${this.environment.config.pssUrl}`);
        }));
    }
    static { this.ɵfac = function SSOComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SSOComponent)(i0.ɵɵdirectiveInject(i1.HttpClient), i0.ɵɵdirectiveInject(i2.LoggingService), i0.ɵɵdirectiveInject(i3.FeatureFlagService), i0.ɵɵdirectiveInject(i4.PermissionsService), i0.ɵɵdirectiveInject(i5.ActivatedRoute), i0.ɵɵdirectiveInject(i6.Environment)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SSOComponent, selectors: [["sso"]], decls: 13, vars: 4, consts: [[1, "sso"], [1, "login_modal_wrapper"], [1, "card"], [1, "card-section"], ["role", "presentation", "alt", "", "src", "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASAAAAB4CAYAAABSKS+uAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAABSbSURBVHgB7Z1dchNJtsdPCatvRHdPtGYFU6yg7fcbgbyCMStArADzRAwSTXEbM3GfMCtArACzAqrjvtw33CvAvYJxRwATgYRq8p9ZsmVVlpRZqixL8v8XIWwX9ZHKj1OZJ8+HCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCHkxhJJoyQdka8HIrfuiEx21QH1t5yrYqjP5Hf180TkKJXgoBzje+p5u3PlOFM/U5Gdd+qcMyGEBKUhAaQH/AP1y6GYwb6A7AwXKEH0RmrnsRI2rZfql67DyakSRPevTxAlschIfdqn6vdzIWsK+hR4cSrEmwYEUL+r/nmtHhWLH2m9AmAAAXgs/iQiz59Jo/RRXz3zOwTyrUTkfwIIZFIdCJ7o7WW/Rju19zlz9qMlQfkFy5z3FYQP6KoZwHszE1gVDOhKwgckIk9eS2MMnl4KHxDFapk4rKceSH3MCh/9t/p93GA/2Q4CCiDMfDBwViGKjRA67Ehl5gd0FbJeg0LowH54dCBkTUDfjmLLf3RX66s3j0ACSL+taxqwUSzyY8V7Pe6JnsHUAYRQ/1CCk5V1YHbstSFiW9REIAE0Siouu8o4yHVJnkRPpVZwv+BvuBJdz3goZE3YSUXvmhZQx4+5YeBBAAGE2U90T2rHV5hg9hPFUi9K+PzQk6C0oatKZw6oDp09FPnfMyFrAnYlJ/v5jm0Ofh/dF+JFgF0wDPxWIH3Jp7+6v2EGSkkoIfQmqdoV25fgYMaXxSJfTvhWXVcwG/6xq9rpvBn7te0jgAAKNvAVkXrD/Dp0O3fwLwmmN/ERhISQMkLogGIJxiR2O+8Rzguoq/k+FkLIyuxI7WAXJ5R9Y+tvbuftxBKUTdsF0S4wsSl3+8zdWA7XQZBri+yz+o3sZsuFZUxIa+LZ7xL6WVWB/vRr3re+O6vfAn6+DkI8w48AAoishrYxmVO4R2qw/PqweO4ACuufrx6bPDSD68L9Rd1v3L2c7I5xHRTbSrfUfmYXKlqPd89cp58/cx10YN/UTt0/T6QS03LBrGEcX5Yrmrl/9upSp9K/V7TjyoZurjpTnz+oBGa/i36W5M8aXt7rwlVnFlWm53eL97bVfaaOHb27emzZPbXQOczru3O1nfqqHaPhar6J8/0ATOtAP+NMdD2U9YWwbJgAmvwhWw8Uz1F37ljZyRgAc+diNqH9yBZZoHfMoB6rgfnL4aWbx7x7ge06DOZbMIsY+ndauMOMk/z5C+4fzdx/dFuKvnu/yVIgyEfLXIC6pq77iXGjGHWkWJ9nJdda6r5lEYrRgntO66NVMqOGszQs+Eeqjf7x0F/oz9Z3GVGs/ump89RnkDTtdhRCB+TQOSrzQcgy1DJ1/MHRBKFjrNUxWOE20/Jwm4EA83GVuXCH6bidP71/5nj+LNr63ee7xHmd/SyNgTK61kcUK6H/1rSRC5j1DN6LV32bC1U7fWjS7SeEADqVYIx/F7IETNm9FfCvc7cZz+ui2M3/6cnLau4wuH/L06ZMD+xE/OlUvK4CWcVnTY6XCwcIHwhup4gPFjDrGr1tyqUkgABqD8VuJboqKY3xvDk3AmmidCpyIqXtEsUO15bRXWylDn1SdigLy6gNL6efeTwGgh6cyZKT0lxI4zudVn/WSpQ8Z9awsey6ZQJ/dJwv3eZJVVveV1qX2+Yz2TN/256J63+o2YvATgAdELTqA6yFH0itQFlIHFFt8O1+UWcA84Q2FKIHi6+FwJhX8i66VivN0+JxrYsq6cgZBv/DogEf3rzfH5h7RrF4sWhwQpB+SYr2W/heO0kY630XdL9+c7UeFoaw6Zp6Lds8sH0PWNIfHVvuhTYYGn3b/HWR6gP9d6ENLAP5gu0kUussyHXXg4iu99GeXWGJGaTefUntl2p3gj17XS+8tmufsn/t2gdRpu7/ed/euSEgXgyVMIG1ucdyXg/arv3/YMD64tBuPIrvddRTZWpU+SpG0KMO7hfrAX8f3Tb1ZKMsMoLNXQnfyyp8Zp/XE2u7RsFnQaG84dHQ96UWMCjGTXeODQazl2VL1bLBNnlY/VqbcWbLMgtGe6LDL7MkRzlGdx2WJVN69sMor4v1/FGi/nkljZHdXT67aGPpaqunbvGQLUSIrutE3Mpja9fd0LqggNvwz9UbuP9sNSmqhc8+dT9eOJgqoONrm5u5ztVymLWWXRvBSHRmxoJlwtimi/B4MaHd+5gFOPQh2w6WzwDU56s+G9WsOrCBbfjn6fLzytQZLct3jSyzouydx47WmbELuoJq4x/QhqkEIrAdEBp/oDpl9tJ/PQ8dwfguhU8oYAlb1aLbdm3rr1f/tgkfLRBSqR1tbGd73jvZeCanjgsVi1DCDHS8okBtxRKQwCFZAWZCmMVkrjqc83zdukfhs8nAoLJAIDOKf5cZ8r2XjafUEHKeoEulUDRkCa0FSU/tOCQit7pK7v1dtNPq1MgMaXngbjCBcvKUnuZbgWVAtP4lzfKn3BhC+mCGo2FXDC2IhvmHbDVYbl33gAi7fFh/nBX4ge9RDp1RSSBajrs3dYAXm00xLnfkxrzssIKYD4XTeuYeP+t6aEAHRG4mI4sND/RCVWJ7O2F73sENylJh2/28I2sOBRAJBGYlVjN/X7MMRwvlzOYE3XHPqKJj5byUjSWzGJ5CAPs4liaNC2sKIBIS285nN3cYdaD/2t18Qwfzty371CDsLxEsF+FLdmVjgXlDQeB3xDlZ4tSJFXXuI7RWgwKIBKRUKCSLOzqWaQgL4eNBD6O9rMSSWfs1fTTBzWbf8ng+hKEOxbHBwmeK1Zq5uzzEBuJATQXwNAxKvxHfOCqhSUAgFLQ1vGUGogOiqc8gFZn8bkwxEHJ30vU3Wp0CgTe6Z79eHxteRgHE32PZLuBDN4Dg6F49DsEyVgJ4gGVaKvLtD2NI2vpJjHPx/Pmx6Lp6smuPxFkfFEAkMHCEHEAZelByQlcNhK75NZPVtu4h8B7tq269JBhZ2f9p04FYNpqdu0oIlwWkOzCfW+KAqsuvwX3juAQjDbAD/69UvIFA8A3DAuX3eN/ffgWuP1HQt30zQAhX+f5XODeJF8N7IjQ8A5oGCceUEFPtKTA3xzQ8S6sHOyfri46OsG9iLzvvgqWqryCAVk+8wcBJ9kws5aXPy3VHn4+N4+XmWRMXmX5/HQ/a1xcsNRlem3GDakgAQfB8e2rW/NDMF6bacT4Nf5BH6U9ubvwfGPDNv72iEteUDLYfZ1IJCP1MqmG7NnNws4Bz8qNhHgAM7ji2bd/0avwnJJgs1IfDs7TQS8zzLtx/OnnQ/9z1B7OeT28uXX/6lvtMPOreVgdtxGeaO8+nzaper7+/EsCPjvP4XHcWLC9RHyfGFarZDK8NiPt/YM2JrcCO33XodMhUUCVViI6NEtARMdtnKt460ClrYtXxO0bwfkqv1w+wf2hRmKfNpOJugtn6BqjznVO5hnQ8UwLPgCoHCBcjrXXWhf3rrCASEp0c8FTWB8tyZbJFiRDWrr5DKqEx81k1y0AUGyF0Y8zpSS3A5mWZ8eE8g5IY1NsQ0mN9CRWSNbZkg6xIFIv8+FYIcWJq0TtrfLjsfKQNsr0sdQC1LQhqtr4EWoKNkprtKbpGr0O9C1mGTksTm9/1z2G++4alR2qM8LSiH/+3m6duLpthJ0KCEiItT5w3as2UpX4hZIrefLD0vSgWE6pixghv2f4L0vi8uKE7sc0RYAmGVCxB6FIXRBajHTKfycogfDDS+JDQBBBA2t4iEH85EEIWAluj0W2pNls+z5P49YQ0QggdUCzBmMRCyFK0Fe++yXp6S81kWvBFW+Dtrg0d3xhraMYjb5IAAihkcGx4SxPiihZE+VIKy3ftatG5NMSDRTeTIFwn9IYnNwQtZFIhawW94Qkh1wYFECHk2uASjJDKwObtq9Ix3fpJ6ZXSmxvBoToUQGvH456amM4HEk+3xyN7W9AGtx9UW03Dy/REnnRFfr0vxBkuwQipxNgSYibrBcx7tpVQABFSjTK7oq4QZyiACKnGWcnxD0KcoQAipBITS8YIhu/whQKIkEogB9cECudTI3ggkMbcKPCEu2CEVAZCCPGGSFU4AyKEXBsUQISQa4NLsK0EcY6/InbSrrHSBd/+VO+bj6rJ39WTZURHH/zZJJlcdH8Y7I3iq9e2T/O8VfPlji3HzmZ+n0lsOX0mlkAvTt3vMS27TgmdR1eY/KE+6h7/5ZGiBmUphHI9r/a9pmWar08k6vQpkywo6wj37V5+Z9w/Ujt27d8c2ussVGYaCqCtQndiJIDsXk5upwkEp3+Pj0UG6dXkfz4MkLomkYvBV3Z/pGNGpx31itlJvw3VPxaL4fHH4rEEwcXO88SWh8VnRnOpZkaWvPC4B8qircxfFsuO8DEI1TpWn/5QDbhnywccBLzNYl0simhbmfp5bjmUKZrJyHGlPh/4lWkeLbAfmHqLytpr7v46nvtcWNsRokwmEgAuwbYGZHbQKWS6Dierc6KhSV3jGuYWb8YB7q8EzNIkk10jTAZPZWW+5lkuspIQqROHLKmg/zoXGEvKDpcKnY8uluCgzVCmKBanMj3eFWdw7gg2SYk4fWe4lfwSIJb7YiiANh685fofygfoIpC65geHvGt6Wu4q3K5cqD4rhuhtPb1cllj5U5YyemoGmStRbAZkSCGEWY9Pm0WxqgtHwagzoL73zEyDQG1D0Smcm4MCaOMZvy0ZoHkALsx05ERKM2Li2h9fSykXebZiqUTk8da2ciAr4yN8Lujk/l6h6Io/DmXSOfnei3cq9ClRLA1CHdBGo5c43eJxGMV9SYqhRhEjuf3acs2BSeBn0wl9e7qgU6r7T3DNqQlvCj1DBoFxJ0xHht4KsZuhFMXSDEr2L6eeN8nLHOV1A8VvqZDrNpSPrsYy6ZdFp/w5GSy4U1OHUDbjWZiJRbFcAxRAG4sOB5EUjyMtzYvEfs00WPsAmWbnOnh0LHpwF55RtkxIRT7dtcRTPjE/dDLAGnRAQAeNv28ZdD7C59wMNJuQ1YIZdWKZrbWgF0klDEvKtFMy8ywrk1ZoW87XpJb2OjPH5VW97eUOl2AbC3Yr5tE7W4ksBTtUMi84OsVQErZn6Oe8MfGJFgVzRzkmdcTGOTcuDqvMQiDARnvlu34QzDv7uaCbv7aGJWDVMrX3/MrUKlEiZ6cNtpcXFECbi0VZOHZMygdblcziNFno2JZnYEB8dlSewlUhq7DVf+V5h/nMbRWS5ffQ9jsWB1MI5hAJMScPVyvTvDJa/90VK+O74oR2LTmRBuESbCNJ1FJhHBePf6em0E/EjcnPxWPRjMDRy6/YcmHimcbmTFYChnIr84fbae2h+s4vi8e/j8VvuedAy7EO20N7mb7OCcXxrvVyPSv2EeDZn+HSahWhANpIrIJBTEQ+V2ydrDXTqbWC0nLO5y0ON4EZxwCCYW5wRwFmQK64linbLREcjc5ofOESbCOZNDAgsrh4DDtd257EL1vD77dSmRzspK4PCiAyw2TLhQtZN7gE2xqgHM4cldCl95gRQDYdBWZFUMgylfEaUtYm0A2lsqZQAG0k350aJ8JZoBM4GkptjNQz2pbjP6x1h77BlCjJI7jCHMuawiXYRpKgsznY8ayC3jmxvFWbN1YjLrRtfQJ0PfvF36RBNkwATRy3U8dnsv3Y7Gte+9ms6NAavs/oqg59KE5o25TGPaxvJknu+2fltZsTK1x7oq40SAABFNVsL3EFx5QnZW/vuvgc8js6klm2V6NY5C8vZSnagx4+YWpq3v9Y3jmzki3c6OXyUBt4667ixEr8yV7Zj0exaYt+ycvgItRKIg0TQABldRiOlTD+3ePkQEICZu3roITVrgm21DA9I1RsnQ2CB7MexImZeohHcXnsHv2MVOwkJgwInpN0Lu8PwQNfs4jCp3HK+gSI4jwGlGrrx8fGbwz+XxA8OhBcV66BAEro9tBuubkyqadF57tA08k1UujtJEqY/L040PXfQ9W5UNZcEGedS2tZm8EaBNejN8U6Ht1XbYqZp2Vpp0NtDI1CfCDmZ3NWtMTGTmLvE1NwPFq29G6MADMg7We0ov+PDR2KwYP2UGpfhmGrexxwhudLkjtq2hwWNRAaXfNZFpenzDcJxzJHXyIbpWUjQVjaJxagTTlSaZBASmgdJqLOwZ/6xy/WgnBFu5gCb2pwjKwZlKdqh9OgntT1/zwpPwVT+8me/zP0iyjAy4gs5qJPeNQ9VAs6saLjRk89BBJA+q1Z0+DXYQsqhgk4Oq5vNoYGcgl1cR2gvo9um3AKzkIiF9CfbruFunhx6tGpcW81ozrqCbkmdJ/omZfLIrst9Gv0g6O963i5BjRExODvd1a0Gzk30/9VKqattozH8PzelcropdcKyxAvTi3C+6M4Mc3UqQNTdfPIerH5P1g5I+Iedim/qWXklxN/Zbpuh57SFSWq6/SM9/ysz5jeAU2VUHszc+/0MhPDlG8lGwS2l9a570z6ldF3zeJlluF6vUc7RQ+L/nvfzqT+MlmYbiTAPANGpLPt9V1azLQR/WS5Sc2qjJmnSXBgMxJVUErr9ejdqzmfqqLTkySi05x4k5ZE/iNkC8EuWRRfPYY4UUdBoiA0YIiImdDotsdSKF8afN6rR/gA6IOeH/otUbQA7C2PJEfIOpJ0xBuYaERx8biX+YsXDe+ZIs7tLSUIWtMlUV5JGOzW6XsgtGl6L1+iTJdm52aZ0kpNgPDggcgJCQhmMujT7bvilNBQJ7V8XzyudZ97EggabRCydSDh4WzOsWk2EdtLdZo9tcwKGquAKhl03aAAImSr0OmnF+QOw4xmmv4HCukoLj8XKxKoIMLBcByEbBXLwsfOGqQumn/ond+K5i/u3BJCyBbxf/8v8t8wJtyV6rGsU2N2Et4uiEswQrYSveHTNXZ4Uex4Ub4DfdSYvyMFECFbj97hwo6v+gnD1FmjRuiDJr+pnyfc+SWEEEIIIYQQQgghhBBCCCGEEEIIIYQQQgghhBBCCCGEEGLjP2HC6AbKMHRBAAAAAElFTkSuQmCC", 1, "il-logo"], ["class", "login-spinner", 4, "ngIf"], [1, "clearfix", "authentication-wrapper"], [4, "ngIf"], [1, "login-spinner"]], template: function SSOComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "section", 0)(1, "section", 1)(2, "div", 2)(3, "div", 3);
            i0.ɵɵelement(4, "img", 4);
            i0.ɵɵtemplate(5, SSOComponent_div_5_Template, 1, 0, "div", 5);
            i0.ɵɵelementStart(6, "div", 6)(7, "div", 3)(8, "h4");
            i0.ɵɵtext(9);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "span");
            i0.ɵɵtext(11);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(12, SSOComponent_section_12_Template, 6, 1, "section", 7);
            i0.ɵɵelementEnd()()()()()();
        } if (rf & 2) {
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.showLoadingImage);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate(ctx.viewModel.title);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.viewModel.message);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", (ctx.viewModel.serverMessage == null ? null : ctx.viewModel.serverMessage.length) > 0);
        } }, dependencies: [i7.NgIf], encapsulation: 2 }); }
}
